import { Typography } from "@mui/material";
import Leistung, { LeistungType } from "./Leistung";
import DryNeedlingNadeln from "./DryNeedlingNadeln";
import Anamnesebogen from "./Anamnsesebogen";
import Blut from "./Blut";
import Heu from "./Heu";
import Pferd from "./Pferd";
import Akupunkturnadeln from "./Akupunkturnadeln";
import Hofmag from "./Hofmag";
import SEO, { SITE_URL } from "../seo/SEO";
import "./leistungen.css";

export default function Leistungen() {
  const leistungen: LeistungType[] = [
    {
      title: "Osteopathie und Physiotherapie",
      beschreibung:
        "Ganzheitliche Behandlungsansätze zur Lösung von Blockaden, Förderung der Beweglichkeit und Stärkung der Muskulatur – für ein gesundes Bewegungsmuster.",
      icon: <Anamnesebogen />,
      link: "osteopathie-und-physiotherapie",
    },
    {
      title: "Biotensegrales Training",
      beschreibung:
        "Ein ganzheitlicher Trainingsansatz, der Balance, Beweglichkeit und Tragfähigkeit fördert und die natürlichen Bewegungsmuster stärkt.",
      icon: <Pferd />,
      link: "biotensegrales-training",
    },
    {
      title: "Blutabnahme und Befundbesprechung",
      beschreibung:
        "Blutproben und deren Interpretation geben Aufschluss über die Gesundheit des Pferdes und unterstützen gezielte Maßnahmen.",
      icon: <Blut />,
      link: "blutabnahme-und-befundbesprechung",
    },
    {
      title: "Hofmag Therapie",
      beschreibung: "Wissenschaftlich geprüfte hochmoderne, gepulste elektromagnetische Feldtherapie (PEMF)",
      icon: <Hofmag />,
      link: "hofmag-therapie"
    },
    {
      title: "Akupunktur",
      beschreibung: "Sanfte Regulation über gezielte Nadelreize – zur Unterstützung bei Atemwegserkrankungen, Stoffwechselproblemen, Verspannungen oder Stress.",
      icon: <Akupunkturnadeln />,
      link: "akupunktur"
    },
    {
      title: "Futterberatung und Rationsberechnung",
      beschreibung:
        "Individuelle Rationsberechnungen und Fütterungspläne schaffen die Grundlage für eine bedarfsgerechte und ausgewogene Ernährung.",
      icon: <Heu />,
      link: "futterberatung-und-rationsberechnung",
    },
    {
      title: "Dry Needling",
      beschreibung: "Gezielte Behandlung von Muskelverspannungen und Triggerpunkten zur Förderung gesunder Bewegungsabläufe und Entspannung.",
      icon: <DryNeedlingNadeln />,
      link: "dry-needling"
    }
  ];
  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Leistungen Pferdeosteopathie Laskowski",
    itemListElement: leistungen.map((l, i) => ({
      "@type": "ListItem",
      position: i + 1,
      url: `${SITE_URL}/leistungen/${l.link}`,
      name: l.title,
    })),
  };
  return (
    <div id="leistungen-wrapper">
      <SEO
        title="Leistungen"
        description="Pferdeosteopathie, Physiotherapie, Biotensegrales Training, Akupunktur, Dry Needling, Hofmag und Futterberatung für Pferde in Hamburg und Umgebung."
        breadcrumbs={[
          { name: "Start", path: "/" },
          { name: "Leistungen", path: "/leistungen" },
        ]}
        jsonLd={itemListSchema}
      />
        <div className="spacing" />
      <div id="leistungen">
        <Typography align="center" variant="h1">
          Leistungen
        </Typography>
        <hr style={{ margin: "2% 5%" }} />
        <div className="leistungen-liste">
          {leistungen.map((leistung) => (
            <Leistung leistung={leistung} key={leistung.link} />
          ))}
        </div>
      </div>
        <div className="spacing" />
    </div>
  );
}
